import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, superAdminOnly = false, requiredPermission = null, allowMfaSetup = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Ładowanie...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.requiresMfaSetup && !allowMfaSetup) {
    return <Navigate to="/app/mfa-settings" replace />;
  }

  if (superAdminOnly && user.role !== 'SUPERADMIN') {
    return <Navigate to="/app/hr/grafik" replace />;
  }

  // Sprawdzanie uprawnień dostępu do sekcji
  if (requiredPermission) {
    // Super Admin ma dostęp do wszystkiego
    if (user.role === 'SUPERADMIN') {
      return children;
    }

    if (user.isPreviewMode && ['Settings', 'Users', 'Departments'].includes(requiredPermission)) {
      return <Navigate to="/app/hr/grafik" replace />;
    }

    // Sprawdzanie konkretnego uprawnienia
    // requiredPermission może być "Cases", "Departments", "Users", "Settings"
    const permissionKey = `canAccess${requiredPermission}`;
    const hasPermission = user[permissionKey] === true;
    
    if (!hasPermission) {
      return <Navigate to="/app/hr/grafik" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
